import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";

export const getKakaoUsersStatistics = async (startDate, endDate, projectId, entryPointId) => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (projectId) params.append("projectId", projectId);
    if (entryPointId) params.append("entryPointId", entryPointId);

    const res = await fetchApi.get(`${API_URL.PROJECT_KAKAO_USERS}?${params.toString()}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getSpotStatistics = async (projectId, spotId, startDate, endDate) => {
    const params = new URLSearchParams({projectId});

    if (spotId) params.append("spotId", spotId);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const res = await fetchApi.get(`${API_URL.STATISTICS_SPOT}?${params.toString()}`);

    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getOrdersStatistics = async (userId, paymentStartDate, paymentEndDate, search, isOffline, page, limit) => {
    const params = new URLSearchParams()

    if (paymentStartDate) params.append("paymentStartDate", paymentStartDate)
    if (paymentEndDate) params.append("paymentEndDate", paymentEndDate)
    if (userId) params.append("userId", userId)
    if (search) params.append("search", search)
    if (isOffline) params.append("isOffline", isOffline)
    if (page) params.append("page", page)
    if (limit) params.append("limit", limit)

    const res = await fetchApi.get(`${API_URL.STATISTICS_ORDERS}?${params.toString()}`);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getMessageOrdersStatistics = async (messageId, page, limit) => {
    const params = new URLSearchParams({
        messageId: messageId,
        page: page,
        limit: limit
    })

    const res = await fetchApi.get(`${API_URL.STATISTICS_ORDERS_MESSAGE}?${params.toString()}`);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getCustomers = async (page, search, startDate, endDate) => {
    const params = new URLSearchParams({page});
    if (search) params.append("search", search);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const res = await fetchApi.get(`${API_URL.CUSTOMERS}?${params.toString()}`)
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}

export const getEntryPointBenefits = async (projectId, startDate, endDate) => {
    const params = new URLSearchParams({projectId});

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const res = await fetchApi.get(`${API_URL.STATISTICS_ENTRYPOINT_BENEFIT}?${params.toString()}`);
    if (res.status === 200) {
        return res.data;
    } else {
        return [];
    }
}
